import api from '../services/api';

export default async function deleteCurso(url) {

  return api
    .delete(url, 
    {
      headers: { 'Content-Type': 'application/json', },
    })
    .then(response => {
      return {type: 'success', data: response.data};
    })
    .catch(error => {
      return {type:'error', data: {code: error.response.status, detail: error.response.data}}
    });
}
